<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
            </div>
                MAPPATURA PIATTI
        </div>    
        <div class="content-form-map">
            <!--<span>
                <a href="#" class="btn btn-outline-success btn-sm" @click="(() => show = !show)">Mappa Piatto</a>
            </span>-->
            
            <div class="main-tab" >
                Seleziona Piatto
                <div class="edit">
                    <select name="portata" id="portata" v-model="selectedDishKey" @change="voceMenuChange">
                    <option disabled value="">Seleziona un piatto</option>
                    <option :value="piatto.nome + '|' + (piatto.portata || '')" v-for="piatto in piatti" :key="piatto.id + '-' + piatto.nome">{{piatto.nome}} ({{piatto.portata || ''}})</option>
                    </select>
                    <!--<button @click="updateMenu" >{{buttonText}}</button>
                    <button v-if="modifica" @click="eliminaPiatto">Elimina Piatto</button>-->
                </div>
            </div>
            <div class="main-map" v-if="vocemenu">
                <div class="nome-piatto" >
                    <span>{{vocemenu}}</span>
                    <span class="costo-totale-cli">Costo Totale: € {{ costoTotaleRicetta }}</span>
                    <span> 
                        <a href="#" class="btn btn-outline-dark btn-sm" @click="incrementcounter">add-product</a>
                        <a href="#" class="btn btn-outline-dark btn-sm" @click="salvaRicetta">Salva Ricetta</a>
                    </span>
                </div>
                <div class="elenco-prodotti" v-if="!piatto.length">
                    <div class="card-piatto" v-for="(count,index) in counter" :key="count">
                        <div class="card-header-actions">
                             <span class="costo-prodotto-cli">€ {{ calcolaCostoProdotto(index) }}</span>
                             <button class="btn-delete-cli" @click="rimuoviProdotto(index)">&times;</button>
                        </div>
                        <input type="text" v-model="searchProd[index]" placeholder="Cerca prodotto..." class="filter-input-cli">
                        <select name="portata" class ="sel-prod" id="portata" v-model="prodottomenu[index]" @change="(e) => prodottomenu[index] =  e.target.value">
                            <option :value="prodotto.code" v-for="prodotto in filteredProdotti(index)" :key="prodotto.code">{{prodotto.descrizio}}</option>
                        </select>
                        <span><input type="text" inputmode="decimal" v-model="quantitaProdotto[index]" @input="(e)=> filterQuantityInput(index, e.target.value)"/></span>
                    </div>
                </div>
                <div class="elenco-prodotti" v-if="piatto.length">
                    <div class="card-piatto" v-for="(count,index) in counter" :key="count">
                        <div class="card-header-actions">
                             <span class="costo-prodotto-cli">€ {{ calcolaCostoProdotto(index) }}</span>
                             <button class="btn-delete-cli" @click="rimuoviProdotto(index)">&times;</button>
                        </div>
                        <input type="text" v-model="searchProd[index]" placeholder="Cerca prodotto..." class="filter-input-cli">
                        <select name="portata" class ="sel-prod" id="portata" v-model="prodottomenu[index]" @change="(e) => prodottomenu[index] =  e.target.value">
                            <option :value="prodotto.code" v-for="prodotto in filteredProdotti(index)" :key="prodotto.code">{{prodotto.descrizio}}</option>
                        </select>
                        <span><input type="text" inputmode="decimal" v-model="quantitaProdotto[index]" @input="(e)=> filterQuantityInput(index, e.target.value)"/></span>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>






<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'TabellaMapP',
  data: function () {
            return {
                prodotti:[],
                show:false,
                piatti:[],
                vocemenu:'',
                selectedDishKey:'',
                counter:[],
                prodottomenu:[],
                quantitaProdotto:[],
                piatto:[],
                portata:'',
                searchProd: [],
                selectedMenuId: null,
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                this.piatti = [];
                console.log('Piatto Aggiunto al menu')
                }else{console.log('Non è stato possibile caricare le sale')}
                response.data.messaggio.forEach(element => {
                    console.log(element.portata)
                  this.piatti.push(element);
                  this.portata = element.portata;
                });
            })
        },
        salvaRicetta() {
            var newP = this.piatto.length? false: true;
            const cleanQuantita = this.quantitaProdotto.map(q => {
                const cleanStr = String(q || '0').replace(',', '.');
                return parseFloat(cleanStr) || 0;
            });
            this.axios.post(this.store.path+'salvaRicetta',{descrizi:this.vocemenu, portata:this.portata, menuId: this.selectedMenuId, prodotti:this.prodottomenu,quantita:cleanQuantita,newP:newP,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                this.vocemenu='';
                this.selectedDishKey='';
                this.prodottomenu =[];
                this.quantitaProdotto=[];
                this.counter=[];
                console.log('Piatto Aggiunto al menu')
                this.displayMenu();
                }else{console.log('Non è stato possibile caricare le sale')}
            })

        },
        voceMenuChange () {
            if (!this.selectedDishKey) return;
            const parts = this.selectedDishKey.split('|');
            const nome = parts[0];
            const portata = parts[1] || '';
            this.vocemenu = nome;
            this.portata = portata;
            const selectedDish = this.piatti.find(p => p.nome === nome && p.portata === portata);
            this.selectedMenuId = selectedDish ? selectedDish.id : null;
            this.displayPiatto(nome, portata);
        },
        displayPiatto(descrizi, portata) {
            this.prodottomenu =[];
            this.quantitaProdotto=[];
            this.counter=[];
            this.piatto = [];
            this.axios.post(this.store.path+'displayPiatto',{descrizi:descrizi,portata:portata,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                response.data.messaggio.forEach((element,i) => {
                    this.counter.push('1');
                    this.prodottomenu[i] = element.nome;
                    this.quantitaProdotto[i] = element.quantita != null ? String(element.quantita).replace('.', ',') : '';
                });
                this.piatto.push('1');
            }else{console.log('Non è stato possibile caricare i prodotti')}
        })
    },
        incrementcounter(){
            this.counter.push('1')
        },
        filteredProdotti(index) {
            const query = (this.searchProd[index] || '').toLowerCase();
            const currentSelected = this.prodottomenu[index];
            
            return this.prodotti.filter(prodotto => {
                const matches = (prodotto.descrizio || '').toLowerCase().includes(query) || 
                              (prodotto.nome || '').toLowerCase().includes(query) ||
                              (prodotto.code || '').toLowerCase().includes(query);
                
                // Keep the selected item in the list even if it doesn't match the filter
                return matches || prodotto.code === currentSelected;
            });
        },
        rimuoviProdotto(index) {
            const productName = this.prodottomenu[index];
            if (this.piatto.length && productName) {
                // If it's a saved dish and product is selected, call server
                this.axios.post(this.store.path + 'rimuoviIngrediente', {
                    descrizi: this.vocemenu,
                    portata: this.portata,
                    nomeIngrediente: productName,
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                }).then(response => {
                    console.log(response.data.messaggio);
                }).catch(err => {
                    console.error("Errore rimozione ingrediente:", err);
                });
            }
            
            // Local removal
            this.prodottomenu.splice(index, 1);
            this.quantitaProdotto.splice(index, 1);
            this.counter.splice(index, 1);
            if (this.searchProd) this.searchProd.splice(index, 1);
        },
        filterQuantityInput(index, value) {
            let sanitized = value.replace(/[^0-9.,]/g, '');
            const firstSeparatorIndex = sanitized.search(/[.,]/);
            if (firstSeparatorIndex !== -1) {
                const before = sanitized.slice(0, firstSeparatorIndex + 1);
                const after = sanitized.slice(firstSeparatorIndex + 1).replace(/[.,]/g, '');
                sanitized = before + after;
            }
            this.quantitaProdotto[index] = sanitized;
        },
        calcolaCostoProdotto(index) {
            const code = this.prodottomenu[index];
            const quantitaStr = String(this.quantitaProdotto[index] || '0').replace(',', '.');
            const quantita = parseFloat(quantitaStr) || 0;
            const prodotto = this.prodotti.find(p => p.code === code);
            if (prodotto && prodotto.prezzo) {
                return ((quantita / 100) * prodotto.prezzo).toFixed(2);
            }
            return '0.00';
        }
    },
    computed: {
        costoTotaleRicetta() {
            let totale = 0;
            this.counter.forEach((_, index) => {
                totale += parseFloat(this.calcolaCostoProdotto(index));
            });
            return totale.toFixed(2);
        }
    },

  beforeMount() {
      this.displayMenu();
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f8f9fa;
    padding-bottom: 50px;
}

.nav-sale {
    padding: 15px;
    background: #343a40;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    font-weight: bold;
}

.content-form-map {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 15px;
}

.main-tab {
    flex: 1;
    min-width: 250px;
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.main-map {
    flex: 3;
    min-width: 300px;
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.nome-piatto {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.elenco-prodotti {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
}

.card-piatto {
    background: #fdfdfd;
    border: 1px solid #eee;
    padding: 15px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.card-piatto input, .edit select, .card-piatto select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
}

.filter-input-cli {
    width: 100%;
    margin-bottom: 5px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
}

.card-header-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: -5px;
}

.btn-delete-cli {
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 2px;
}

.btn-delete-cli:hover {
    background: #c82333;
}

@media (max-width: 768px) {
    .content-form-map {
        flex-direction: column;
    }
    .elenco-prodotti {
        grid-template-columns: 1fr;
    }
}
</style>